// src/client/services/tours/getAgentTours.js
import { apiClient } from "@/shared/services/apiClient";

export const getAgentTours = ({ auth0UserId, accessToken, tourStatus = "scheduled" }) => {
	const url = `/api/v1/leasing/users/${auth0UserId}/tours${tourStatus ? `?status=${tourStatus}` : ""}`;
	return apiClient(url, {
		accessToken,
		errorMessage: "Failed to fetch agent tours",
	});
};
